import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { useBasket } from '../../basket'

const useAddLineItemsFromQuery = () => {
  const router = useRouter()

  const {
    addLineItems: [addLineItems, addLineItemsResponse],
  } = useBasket()

  useEffect(() => {
    if (router.query.id) {
      addLineItems(router.query.id as string[])
    }
  }, [addLineItems, router.query.id])

  return addLineItemsResponse
}

export default useAddLineItemsFromQuery
